import GlobalHelper from "../../common/GlobalHelper.jsx"
import {ContactAttributesDto} from "../../state/contact/models"
import {SelectOption} from "../../common/types"


export const processRawEmail = (raw: string): Array<string> => {
    let emails: Array<string> = []
    if (raw.includes(",")) {
        emails = raw.split(",")
    } else if (raw.includes(";")) {
        emails = raw.split(";")
    } else {
        emails.push(raw)
    }
    return emails
}

export const getValuesFromRawEmail = (raw: string, name?: string): Array<SelectOption<string>> => {
    const emails = processRawEmail(raw)
    return emails.map((email: string) => {
        if (email) {
            return {
                value: name ? name + " <" + email.trim() + ">" : email,
                label: name ? name + " <" + email.trim() + ">" : email
            }
        } else {
            return {
                value: name + " <" + "" + ">",
                label: name + " <" + "" + ">"
            }
        }
    })
}

export const validateSelectedEmails = (selectedOptions: Array<SelectOption<string>>): boolean => {
    for (const option of selectedOptions || []) {
        if (option) {
            const value = option.value
            let email = value.substring(value.lastIndexOf("<") + 1, value.lastIndexOf(">"))
            if (!email) {
                email = value
            }
            if (!GlobalHelper.validateEmail(email)) {
                return false
            }
        }
    }
    return true
}

// Validate email based on email type
export const validateEmail = (contact: ContactAttributesDto): boolean => {
    if (Array.isArray(contact.email)) {
        return contact.email.length > 0 && !!contact.email.find(e => !!e)
    } else {
        return !!contact.email
    }
}



// WEBPACK FOOTER //
// ./src/utils/email/utils.ts